import { render, staticRenderFns } from "./submission.vue?vue&type=template&id=37665f28&scoped=true"
import script from "./submission.vue?vue&type=script&lang=js"
export * from "./submission.vue?vue&type=script&lang=js"
import style0 from "./submission.vue?vue&type=style&index=0&id=37665f28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37665f28",
  null
  
)

export default component.exports